export interface IdleTimerOptions {
  idleMs: number;
  warningMs: number;
  onWarning: () => void;
  onLockout: () => void;
}

export interface IdleTimerHandle {
  start: () => void;
  reset: () => void;
  stop: () => void;
}

export function createIdleTimer(opts: IdleTimerOptions): IdleTimerHandle {
  let warnTimer: ReturnType<typeof setTimeout> | null = null;
  let lockTimer: ReturnType<typeof setTimeout> | null = null;

  const clear = (): void => {
    if (warnTimer !== null) clearTimeout(warnTimer);
    if (lockTimer !== null) clearTimeout(lockTimer);
    warnTimer = null;
    lockTimer = null;
  };

  const schedule = (): void => {
    clear();
    warnTimer = setTimeout(opts.onWarning, opts.idleMs - opts.warningMs);
    lockTimer = setTimeout(opts.onLockout, opts.idleMs);
  };

  return {
    start: schedule,
    reset: schedule,
    stop: clear,
  };
}
